module.exports = __webpack_public_path__ + "static/leucrotta-1ff3de49ed880f721fcc690be868e486.jpeg";